import React from 'react';
import { motion } from 'framer-motion';
const vehicles = [{
  name: 'Dodge Ram',
  image: 'https://images.unsplash.com/photo-1609521263047-f8f205293f24?auto=format&fit=crop&w=600&q=80'
}, {
  name: 'Ford F-Series',
  image: 'https://images.unsplash.com/photo-1544636331-e26879cd4d9b?auto=format&fit=crop&w=600&q=80'
}, {
  name: 'Jeep Wrangler',
  image: 'https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?auto=format&fit=crop&w=600&q=80'
}, {
  name: 'Chevy Silverado',
  image: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?auto=format&fit=crop&w=600&q=80'
}, {
  name: 'Toyota Tacoma',
  image: 'https://images.unsplash.com/photo-1559416523-140ddc3d238c?auto=format&fit=crop&w=600&q=80'
}, {
  name: 'GMC Sierra',
  image: 'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?auto=format&fit=crop&w=600&q=80'
}];
export function ShopByVehicle() {
  return <section className="w-full bg-white py-20" data-id="element-177">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8" data-id="element-178">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-charcoal uppercase italic text-center mb-12 tracking-tight" data-id="element-179">
          Shop By <span className="text-primary" data-id="element-180">Vehicle</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-181">
          {vehicles.map(vehicle => <motion.div key={vehicle.name} whileHover={{
          scale: 1.02
        }} className="relative h-[240px] overflow-hidden group cursor-pointer border-b-4 border-primary" data-id="element-182">
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0" style={{
            backgroundImage: `url(${vehicle.image})`
          }} data-id="element-183" />
              <div className="absolute inset-0 bg-charcoal/60 group-hover:bg-charcoal/40 transition-colors" data-id="element-184" />

              {/* Diagonal accent */}
              <div className="absolute top-0 right-0 w-20 h-full bg-gradient-to-l from-primary/20 to-transparent skew-x-[-20deg] translate-x-10 group-hover:translate-x-0 transition-transform duration-500" data-id="element-185"></div>

              <div className="absolute inset-0 flex items-center justify-center" data-id="element-186">
                <h3 className="text-3xl font-heading font-bold text-white uppercase italic tracking-wide text-center px-4 drop-shadow-lg group-hover:scale-110 transition-transform duration-300" data-id="element-187">
                  {vehicle.name}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}